import { Link } from "react-router-dom";
import { HomePlateLogo } from "@/components/HomePlateLogo";

const columns = [
  {
    label: "Product",
    links: [
      { label: "Pricing", href: "/#pricing" },
      { label: "Sign up", to: "/signup" },
    ],
  },
  {
    label: "Company",
    links: [
      {
        label: "LinkedIn",
        href: "https://www.linkedin.com/company/the-box-score-club",
        external: true,
      },
      { label: "Contact", href: "mailto:clubhouse@theboxscoreclub.com" },
    ],
  },
  {
    label: "Legal",
    links: [
      { label: "Terms", to: "/terms" },
      { label: "Privacy", to: "/privacy" },
    ],
  },
];

function FooterLink({ link }) {
  const cls = "text-white/60 hover:text-brand-paper transition-colors";
  if (link.to) {
    return (
      <Link to={link.to} className={cls}>
        {link.label}
      </Link>
    );
  }
  return (
    <a
      href={link.href}
      className={cls}
      {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      {link.label}
    </a>
  );
}

export function SiteFooter() {
  return (
    <footer className="bg-brand-black text-white border-t-[3px] border-brand-red">
      <div className="max-w-7xl mx-auto px-6 pt-14 pb-10 md:pt-16 md:pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-10">
          <div className="md:col-span-6">
            <Link
              to="/"
              className="inline-flex items-center gap-3.5 hover:opacity-80 transition-opacity"
              data-testid="footer-wordmark"
            >
              <span className="inline-flex items-center justify-center bg-brand-paper p-1.5">
                <HomePlateLogo size={40} />
              </span>
              <span className="flex flex-col">
                <span className="font-serif text-xl font-bold tracking-[0.04em] uppercase text-white leading-none whitespace-nowrap">
                  The Box Score Club
                </span>
                <span
                  className="mt-1.5 inline-block font-mono text-[10px] font-semibold tracking-[0.24em] text-brand-red uppercase"
                  data-testid="footer-est-tag"
                >
                  Est. 2026
                </span>
              </span>
            </Link>
            <p className="mt-6 font-serif text-lg italic text-white/70 leading-relaxed max-w-sm">
              Daily MLB recaps that don't suck.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.label} className="md:col-span-2">
              <p className="font-mono text-[11px] font-semibold text-brand-red uppercase tracking-[0.22em]">
                {col.label}
              </p>
              <ul className="mt-5 space-y-3.5 text-sm">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-white/40">
            © 2026 The Box Score Club
          </p>
          <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-white/40">
            Not affiliated with MLB or any team
          </p>
        </div>
      </div>
    </footer>
  );
}
